import _regenerator from "/usr/app/node_modules/@babel/runtime/helpers/esm/regenerator.js";
import _asyncToGenerator from "/usr/app/node_modules/@babel/runtime/helpers/esm/asyncToGenerator.js";
import _objectSpread from "/usr/app/node_modules/@babel/runtime/helpers/esm/objectSpread2.js";
import React from "react";
var __jsx = React.createElement;
import { createContext, useContext, useEffect, useState } from "react";
import { useTranslation } from "@i18n";
import { useSession } from "@/_MiniApps/auth/AuthContext";
import { api__getFinanceApplyOrderV2 } from "@/apis/orders/orders";
import useLocalStorage from "@hooks/useLocalStorage";
import { useLang } from "@/common/Contexts/LanguageContext";
import useHelpers from "@hooks/useHelpers";
import useIsMobile from "@hooks/useIsMobile";
var extractAndValidationQueryParams = function extractAndValidationQueryParams() {
  var searchParams = new URLSearchParams(__IS_CSR__ ? window.location.search : "");
  var financestep = Number(searchParams.get("financestep")) || 1;
  var post_id = Number(searchParams.get("post_id"));
  var ref = searchParams.get("ref") === 'tamaraForm' ? 'tamaraForm' : null;
  return {
    post_id: post_id,
    financestep: financestep,
    ref: ref
  };
};
var TamaraFinanceContext = /*#__PURE__*/createContext(null);
export function useTamaraFinance() {
  return useContext(TamaraFinanceContext);
}
var hasTamara = function hasTamara() {
  var bnplOptions = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : [];
  return bnplOptions.includes('tamara');
};

// @ts-ignore
export var TamaraFinanceContextProvider = function TamaraFinanceContextProvider(_ref) {
  var children = _ref.children;
  var _useTranslation = useTranslation(["web_checkout_finance"]),
    t = _useTranslation.t;
  var lang = useLang();
  var _useHelpers = useHelpers(),
    navigateToHard = _useHelpers.navigateToHard;
  var _useSession = useSession(),
    sessionUser = _useSession.user;
  var _useState = useState(null),
    fetching_error = _useState[0],
    setFetching_error = _useState[1];
  var _useState2 = useState(true),
    fetch_loading = _useState2[0],
    setFetch_loading = _useState2[1];
  var _useLocalStorage = useLocalStorage(true),
    getLocalStorage = _useLocalStorage.getLocalStorage,
    setLocalStorage = _useLocalStorage.setLocalStorage,
    removeLocalStorage = _useLocalStorage.removeLocalStorage;
  var _useState3 = useState(null),
    checkoutOrderV2 = _useState3[0],
    setCheckoutOrderV2 = _useState3[1];
  var queryParams = extractAndValidationQueryParams();
  var isMobile = useIsMobile();
  var _useState4 = useState(function () {
      var _checkoutOrderV2$post;
      var defaultUserInfo = {
        whatsapp_optin: 1,
        first_name: null,
        fathers_name: null,
        family_name: null,
        birth_date: null,
        birth_date_calendar_type: "G",
        mobile_number: (sessionUser === null || sessionUser === void 0 ? void 0 : sessionUser.phone_number) || null,
        city_id: (sessionUser === null || sessionUser === void 0 ? void 0 : sessionUser.city_id) || (checkoutOrderV2 === null || checkoutOrderV2 === void 0 ? void 0 : (_checkoutOrderV2$post = checkoutOrderV2.post) === null || _checkoutOrderV2$post === void 0 ? void 0 : _checkoutOrderV2$post.city_id) || "",
        gender: null,
        id_number: null
      };
      try {
        var storedUserInfo = getLocalStorage("tamara_user_info_".concat(queryParams.post_id));
        return storedUserInfo ? _objectSpread(_objectSpread({}, defaultUserInfo), storedUserInfo) : defaultUserInfo;
      } catch (error) {
        console.error("Error loading user info from localStorage:", error);
        return defaultUserInfo;
      }
    }),
    userInfo = _useState4[0],
    setUserInfo = _useState4[1];
  var _useState5 = useState(function () {
      var defaultOrderData = {
        order_id: null,
        order_uuid: null,
        transaction_id: null,
        skipToUploadPage: false,
        reachTamaraOtpStep: false,
        payment_enabled: false,
        ranges: [],
        payment_fee_default_value: 0,
        amount: 0
      };
      try {
        var storedOrderData = getLocalStorage("tamara_order_data_".concat(queryParams.post_id));
        return storedOrderData ? _objectSpread(_objectSpread({}, defaultOrderData), storedOrderData) : defaultOrderData;
      } catch (error) {
        console.error("Error loading order data from localStorage:", error);
        return defaultOrderData;
      }
    }),
    orderData = _useState5[0],
    setOrderData = _useState5[1];

  // Actions
  var action__updateUserInfo = function action__updateUserInfo(updates) {
    setUserInfo(function (prevUserInfo) {
      var updatedUserInfo = _objectSpread(_objectSpread({}, prevUserInfo), updates);
      try {
        setLocalStorage("tamara_user_info_".concat(queryParams.post_id), updatedUserInfo);
      } catch (error) {
        console.error("Error saving user info to localStorage:", error);
      }
      return updatedUserInfo;
    });
  };
  var action__updateOrderInfo = function action__updateOrderInfo(updates) {
    setOrderData(function (prevOrderData) {
      var updatedOrderData = _objectSpread(_objectSpread({}, prevOrderData), updates);
      try {
        setLocalStorage("tamara_order_data_".concat(queryParams.post_id), updatedOrderData);
      } catch (error) {
        console.error("Error saving order data to localStorage:", error);
      }
      return updatedOrderData;
    });
  };
  var action__clearLocalStorageData = function action__clearLocalStorageData() {
    try {
      var _checkoutOrderV2$post2;
      removeLocalStorage("tamara_user_info_".concat(queryParams.post_id));
      removeLocalStorage("tamara_order_data_".concat(queryParams.post_id));

      // Reset to default values
      setUserInfo({
        whatsapp_optin: 1,
        first_name: null,
        fathers_name: null,
        family_name: null,
        birth_date: null,
        birth_date_calendar_type: "G",
        mobile_number: (sessionUser === null || sessionUser === void 0 ? void 0 : sessionUser.phone_number) || null,
        city_id: (sessionUser === null || sessionUser === void 0 ? void 0 : sessionUser.city_id) || (checkoutOrderV2 === null || checkoutOrderV2 === void 0 ? void 0 : (_checkoutOrderV2$post2 = checkoutOrderV2.post) === null || _checkoutOrderV2$post2 === void 0 ? void 0 : _checkoutOrderV2$post2.city_id) || "",
        gender: null,
        id_number: null,
        order_id: null
      });
      setOrderData({
        order_id: null,
        order_uuid: null,
        transaction_id: null,
        skipToUploadPage: false,
        reachTamaraOtpStep: false,
        payment_enabled: false,
        ranges: [],
        payment_fee_default_value: 0,
        amount: 0
      });
    } catch (error) {
      console.error("Error clearing localStorage data:", error);
    }
  };

  // Fetch checkout order only - post data is not needed as checkoutOrder contains all necessary info
  var fetch__CheckoutOrder = /*#__PURE__*/function () {
    var _ref2 = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee() {
      var orderResponse, _t;
      return _regenerator().w(function (_context) {
        while (1) switch (_context.p = _context.n) {
          case 0:
            if (queryParams.post_id) {
              _context.n = 1;
              break;
            }
            setFetch_loading(false);
            return _context.a(2);
          case 1:
            _context.p = 1;
            setFetch_loading(true);

            // Fetch only checkout order - it contains all necessary data including post details
            _context.n = 2;
            return api__getFinanceApplyOrderV2(queryParams.post_id, 'tamara', {
              city_id: Number(userInfo.city_id)
            }, isMobile);
          case 2:
            orderResponse = _context.v;
            if (!hasTamara((orderResponse === null || orderResponse === void 0 ? void 0 : orderResponse.bnpl_options) || [])) navigateToHard("/?ref=not_tamara_order");
            setCheckoutOrderV2(orderResponse);
            _context.n = 4;
            break;
          case 3:
            _context.p = 3;
            _t = _context.v;
            console.error("Error fetching checkout order:", _t);
            setFetching_error(_t);
          case 4:
            _context.p = 4;
            setFetch_loading(false);
            return _context.f(4);
          case 5:
            return _context.a(2);
        }
      }, _callee, null, [[1, 3, 4, 5]]);
    }));
    return function fetch__CheckoutOrder() {
      return _ref2.apply(this, arguments);
    };
  }();
  var fetch__getOrderDetailsByParamsV2 = /*#__PURE__*/function () {
    var _ref3 = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee2() {
      var overrides,
        order,
        _args2 = arguments,
        _t2;
      return _regenerator().w(function (_context2) {
        while (1) switch (_context2.p = _context2.n) {
          case 0:
            overrides = _args2.length > 0 && _args2[0] !== undefined ? _args2[0] : {};
            _context2.p = 1;
            _context2.n = 2;
            return api__getFinanceApplyOrderV2(queryParams.post_id, 'tamara', {
              city_id: overrides.city_id != null ? Number(overrides.city_id) : Number(userInfo.city_id),
              warranty_id: overrides.warranty_id,
              order_id: overrides.order_id
            }, isMobile);
          case 2:
            order = _context2.v;
            setCheckoutOrderV2(order);
            return _context2.a(2, true);
          case 3:
            _context2.p = 3;
            _t2 = _context2.v;
            return _context2.a(2, false);
        }
      }, _callee2, null, [[1, 3]]);
    }));
    return function fetch__getOrderDetailsByParamsV2() {
      return _ref3.apply(this, arguments);
    };
  }();

  // Fetch checkout order on mount
  useEffect(function () {
    fetch__CheckoutOrder();
  }, [queryParams.post_id]);

  // Update city_id from checkoutOrder after it's fetched (only if no sessionUser.city_id and userInfo.city_id not already set)
  useEffect(function () {
    var _checkoutOrderV2$post3;
    if (checkoutOrderV2 !== null && checkoutOrderV2 !== void 0 && (_checkoutOrderV2$post3 = checkoutOrderV2.post) !== null && _checkoutOrderV2$post3 !== void 0 && _checkoutOrderV2$post3.city_id && !(sessionUser !== null && sessionUser !== void 0 && sessionUser.city_id) && (!userInfo.city_id || userInfo.city_id === "")) {
      action__updateUserInfo({
        city_id: checkoutOrderV2.post.city_id
      });
    }
  }, [checkoutOrderV2]);

  // Update userInfo when sessionUser changes (login/logout)
  // This ensures that when a user logs in, their phone number is updated in the context.
  // The city_id is preserved from the user's selection (if already set) rather than overriding with session value.
  useEffect(function () {
    if (sessionUser !== null && sessionUser !== void 0 && sessionUser.phone_number) {
      // User is logged in - update mobile number from session
      // Keep existing city_id if user has already selected one (from localStorage or context)
      action__updateUserInfo(_objectSpread(_objectSpread({
        mobile_number: sessionUser.phone_number
      }, userInfo.city_id && {
        city_id: userInfo.city_id
      }), !userInfo.city_id && sessionUser.city_id && {
        city_id: sessionUser.city_id
      }));
    }
    // If user is logged out (sessionUser is null), keep the existing values from localStorage/context
  }, [sessionUser === null || sessionUser === void 0 ? void 0 : sessionUser.phone_number, sessionUser === null || sessionUser === void 0 ? void 0 : sessionUser.city_id]);

  // Collections
  var actions = {
    action__updateUserInfo: action__updateUserInfo,
    action__updateOrderInfo: action__updateOrderInfo,
    action__clearLocalStorageData: action__clearLocalStorageData
  };
  var state = {
    userInfo: userInfo,
    orderData: orderData,
    fetching_error: fetching_error,
    fetch_loading: fetch_loading,
    checkoutOrderV2: checkoutOrderV2
  };
  var remote_actions = {
    fetch__getOrderDetailsByParamsV2: fetch__getOrderDetailsByParamsV2,
    fetch__CheckoutOrder: fetch__CheckoutOrder
  };
  return /*#__PURE__*/React.createElement(TamaraFinanceContext.Provider, {
    value: {
      actions: actions,
      state: state,
      remote_actions: remote_actions,
      queryParams: queryParams
    }
  }, children);
};
export default TamaraFinanceContextProvider;